import cpfValidation from './cpfValidation';
import emailValidation from './emailValidation';
import passwordValidation from './passwordValidation';

export default { cpfValidation, emailValidation, passwordValidation };
